import './SiteFooter.css';
import { FOOTER_PAGES, FOOTER_SOCIAL, FOOTER_TEXT, type FooterLink, MAIN_SITE, withBase } from './siteFooterModel';

export interface SiteFooterProps {
  /** Base das páginas institucionais: vazia no mapa.voto; o endereço dele no replay e nas pesquisas. */
  base?: string;
  /** `div` quando vai dentro do rodapé que a página já tem (um só marco `contentinfo`). */
  as?: 'footer' | 'div';
}

function FooterAnchor({ l, cls, icon, base }: { l: FooterLink; cls: string; icon: boolean; base: string }) {
  return (
    <a
      class={`${cls}${icon ? ` ${cls}--${l.id}` : ''}`}
      href={withBase(base, l.href)}
      {...(l.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      aria-label={l.aria}
      data-testid={`site-footer-${l.id}`}
    >
      {icon ? <span class="site-footer__icon" aria-hidden="true" /> : null}
      <span class="site-footer__label">{l.label}</span>
    </a>
  );
}

/**
 * O rodapé dos três sites (ORD-F-145): Instagram, YouTube e e-mail com ícone e rótulo, as páginas do site e "powered by
 * mapa.voto". A mesma árvore de `siteFooterHtml` (as páginas sem JS) e o mesmo CSS. Discreto, no tema escuro.
 */
export function SiteFooter({ base = '', as: Tag = 'footer' }: SiteFooterProps) {
  return (
    <Tag class="site-footer" data-testid="site-footer">
      <ul class="site-footer__social" aria-label={FOOTER_TEXT.social}>
        {FOOTER_SOCIAL.map((l) => (
          <li key={l.id}>
            <FooterAnchor l={l} cls="site-footer__social-link" icon base={base} />
          </li>
        ))}
      </ul>
      <nav class="site-footer__nav" aria-label={FOOTER_TEXT.pages}>
        <ul class="site-footer__pages">
          {FOOTER_PAGES.map((l) => (
            <li key={l.id}>
              <FooterAnchor l={l} cls="site-footer__page" icon={false} base={base} />
            </li>
          ))}
        </ul>
      </nav>
      <p class="site-footer__powered">
        <a class="site-footer__home" href={MAIN_SITE} data-testid="site-footer-home">
          {FOOTER_TEXT.powered}
        </a>
      </p>
    </Tag>
  );
}
